// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    Redirect,
    useHistory,
    useLocation,
    useParams,
} from 'react-router-dom'

// data
import {
    defaultReduxState,
    languageObjectSite,
    reduxModalSliderDetailShowHideSite,
} from 'data'

// pages
import {
    ComingSoonSite,
    LearnPageSite,
    NotFoundWrapperSite,
    PrivateDetailPageSite,
} from 'pages'

// services
import {
    getHostOriginSite,
    parseQuerySite,
    stringifyQuery,
} from 'services'

// props
type MatchParams = {
    devId: string
    param1: string
    param2: string
    param3: string
    param4: string
    param5: string
}

// main
export const Param5WrapperSite: React.FC = () => {

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const params = useParams<MatchParams>()
    const reduxCacheSiteportfoliocoming_soon = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.coming_soon)
    const reduxCacheSiteportfoliourl_redirect = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.url_redirect)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const [locationKeys, setLocationKeys] = useState<any[]>([])

    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {

                let listUrl = `${location.pathname}`  // Keep quotes
                const parsed = parseQuerySite(location.search)
                delete parsed.modal_page
                delete parsed.modal_detail_id
                if (parsed && Object.keys(parsed).length > 0 && parsed.constructor === Object) {
                    listUrl += `?${stringifyQuery(parsed)}`
                }

                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    if (parseQuerySite(location.search)?.modal_page) {
                        dispatch(reduxModalSliderDetailShowHideSite(
                            true,
                            listUrl,
                            parseQuerySite(location.search)?.modal_detail_id,
                        ))
                    }
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    if (parseQuerySite(location.search)?.modal_page) {
                        dispatch(reduxModalSliderDetailShowHideSite(
                            true,
                            listUrl,
                            parseQuerySite(location.search)?.modal_detail_id,
                        ))
                    }
                }
            }
        })
    }, [
        locationKeys,
    ])

    if (reduxCacheSiteportfoliocoming_soon) {
        return (
            <ComingSoonSite />
        )
    }

    const searchParams = parseQuerySite(location.search)
    const modal_page = searchParams.modal_page
    const modal_detail_id = searchParams.modal_detail_id

    if (!reduxModalSite.isOpen && !reduxModalSite.noRedirect && modal_page) {
        if (languageObjectSite[params.param1]) {
            return <Redirect to={`${reduxModalSite.rootUrl}${params.param1}/${modal_page}${modal_detail_id ? `/${modal_detail_id}` : ''}`} />
        }
        return <Redirect to={`${reduxModalSite.rootUrl}${modal_page}${modal_detail_id ? `/${modal_detail_id}` : ''}`} />
    }

    if (reduxCacheSiteportfoliourl_redirect?.length! > 0) {
        const hostOriginSite = getHostOriginSite()
        let redirectUrl = ''
        let remainingUrl = ''

        if (languageObjectSite[params.param1]) {
            const urlLang = params.param1
            remainingUrl = `${location.pathname.split(`/${params.param1}/`)[1]}${location.search}`

            // Check for redirect with language prefix first
            const fullUrlWithLang = `${urlLang}/${location.pathname.split(`/${params.param1}/`)[1]}${location.search}`
            let redirectObj = reduxCacheSiteportfoliourl_redirect!.find((obj) =>
                obj.old_url === fullUrlWithLang ||
                `${obj.old_url}/` === fullUrlWithLang ||
                obj.old_url === remainingUrl ||
                `${obj.old_url}/` === remainingUrl
            )

            // If redirect not found with location search, try without location search
            if (!redirectObj && location.search) {
                const remainingUrlWithoutSearch = `${location.pathname.split(`/${params.param1}/`)[1]}`
                const fullUrlWithLangWithoutSearch = `${urlLang}/${remainingUrlWithoutSearch}`
                redirectObj = reduxCacheSiteportfoliourl_redirect!.find((obj) =>
                    obj.old_url === fullUrlWithLangWithoutSearch ||
                    `${obj.old_url}/` === fullUrlWithLangWithoutSearch ||
                    obj.old_url === remainingUrlWithoutSearch ||
                    `${obj.old_url}/` === remainingUrlWithoutSearch
                )
            }

            if (redirectObj) {
                // Check if the redirect URL already includes the language prefix
                const redirectUrlStartsWithLang = (redirectObj.new_url as string).startsWith(`${urlLang}/`)

                if (hostOriginSite === 'prod') {
                    if (redirectUrlStartsWithLang) {
                        redirectUrl = `/${redirectObj.new_url}`
                    } else {
                        redirectUrl = `/${urlLang}/${redirectObj.new_url}`
                    }
                } else {
                    if (redirectUrlStartsWithLang) {
                        redirectUrl = `/${params.devId}/${redirectObj.new_url}`
                    } else {
                        redirectUrl = `/${params.devId}/${urlLang}/${redirectObj.new_url}`
                    }
                }
            }
        } else {
            if (hostOriginSite === 'prod') {
                remainingUrl = `${location.pathname.substring(1)}${location.search}`
            } else {
                remainingUrl = `${location.pathname.split(params.devId)[1]?.substring(1)}${location.search}`
            }
            let redirectObj = reduxCacheSiteportfoliourl_redirect!.find((obj) => obj.old_url === remainingUrl || `${obj.old_url}/` === remainingUrl)

            // If redirect not found with location search, try without location search
            if (!redirectObj && location.search) {
                let remainingUrlWithoutSearch = ''
                if (hostOriginSite === 'prod') {
                    remainingUrlWithoutSearch = `${location.pathname.substring(1)}`
                } else {
                    remainingUrlWithoutSearch = `${location.pathname.split(params.devId)[1]?.substring(1)}`
                }
                redirectObj = reduxCacheSiteportfoliourl_redirect!.find((obj) => obj.old_url === remainingUrlWithoutSearch || `${obj.old_url}/` === remainingUrlWithoutSearch)
            }

            if (redirectObj) {
                if (hostOriginSite === 'prod') {
                    redirectUrl = `/${redirectObj.new_url}`
                } else {
                    redirectUrl = `/${params.devId}/${redirectObj.new_url}`
                }
            }
        }

        if (redirectUrl) {
            return <Redirect to={redirectUrl} />
        }
    }

    if (languageObjectSite[params.param1] && params.param2 === 'extra' && params.param3 === 'private') {
        return (
            <PrivateDetailPageSite
                detailId={params.param5}
                devId={params.devId}
                pageSlug={params.param4}
            />
        )
    }

    if (params.param1 === 'extra' && params.param2 === 'learn') {
        return (
            <LearnPageSite
                detailId={params.param5}
                devId={params.devId}
                learnPageSlug={params.param3}
                pageSlug={params.param4}
            />
        )
    }

    return (
        <NotFoundWrapperSite devId={params.devId} />
    )
}
